import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isProjectFeatureEnabled } from './lensFeatures';

// Route to feature key mapping
const ROUTE_TO_FEATURE_KEY = {
    '/overview': 'project_overview',
    '/maturity-index': 'maturity_index',
    '/security-index': 'security_index',
    '/team-analyser': 'team_analyser',
    '/security-governance': 'security_governance',
    '/dataroom': 'dataroom',
    '/wizard': 'dataroom_wizard',
    '/irl': 'information_requests',
    '/observations': 'observations',
    '/lessons': 'lessons_learnt',
    '/journal': 'journal',
    '/journal/analysis': 'journal',
    '/tent': 'the_tent',
    '/tasks': 'project_management',
    '/raid': 'raid_log',
    '/action-log': 'action_log',
    '/software-inventory': 'software_inventory',
    '/hardware-inventory': 'hardware_inventory',
    '/ticket-management': 'ticket_management',
    '/lens-intelligence': 'lens_intelligence',
    '/lens-intelligence/insights': 'lens_intelligence',
};

// Features that cannot be disabled (always enabled)
const REQUIRED_FEATURES = ['project_overview', 'dataroom'];

// For users without diligence tools, only this subset is allowed.
const VDR_ALLOWED_FEATURES = ['project_overview', 'dataroom', 'dataroom_wizard', 'information_requests'];

const FeatureProtectedRoute = ({ children, featureKey, route }) => {
    const location = useLocation();
    const { selectedProject } = useSelector(state => state.projectData);
    const { user } = useSelector(state => state.user);

    // Determine feature key from route or prop
    const feature = featureKey || (route ? ROUTE_TO_FEATURE_KEY[route] : null);

    if (!feature) {
        // If no feature key mapping, allow access (backward compatibility)
        return children;
    }

    // Strict VDR experience: only a limited feature subset is accessible.
    if (!user?.has_diligence_tools && !VDR_ALLOWED_FEATURES.includes(feature)) {
        return <Navigate to="/dataroom" state={{ from: location }} replace />;
    }

    // Required features are always enabled
    if (REQUIRED_FEATURES.includes(feature)) {
        return children;
    }

    const enabledFeatures = selectedProject?.enabled_features;

    if (!isProjectFeatureEnabled(enabledFeatures, feature)) {
        return <Navigate to="/project" state={{ from: location }} replace />;
    }

    return children;
};

export default FeatureProtectedRoute;
